'use strict';

angular.module('basketModule')
.service('BasketService', BasketService);

function BasketService (Basket, $http, $window, notify, appConfig)
{
    this.enabled = () =>
    {
        if (!appConfig.basket) {
            return true;
        }

        return appConfig.basket.enabled;
    };

    this.init = () =>
    {
        if (!this.enabled()) {
            return;
        }

        return Basket.findAll({
            'with': 'thumbnail,file'
        })
        .then((basketItems) => basketItems);
    };

    this.add = (file) =>
    {
        if (!this.enabled()) {
            throw new Error('Basket is disabled!');
        }

        if (!file.in_basket) {
            Basket.create({
                file_id: file.id
            });

            file.in_basket = true;
        }
    };

    this.remove = (file) =>
    {
        if (!this.enabled()) {
            throw new Error('Basket is disabled!');
        }

        if (file.in_basket) {
            const basket = Basket.filter({
                'where': {
                    'file_id': {
                        '==': file.id
                    }
                }
            })[0];

            Basket.destroy(basket.id);
            file.in_basket = false;
        }
    };

    this.removeAll = () =>
    {
        if (!this.enabled()) {
            throw new Error('Basket is disabled!');
        }

        this.get().map((basketItem) => this.remove(basketItem.file));
    };

    this.inBasket = (fileId) =>
    {
        if (!this.enabled()) {
            throw new Error('Basket is disabled!');
        }

        return this.get().some((item) => item.file_id === fileId);
    };

    this.length = () =>
    {
        if (!this.enabled()) {
            throw new Error('Basket is disabled!');
        }

        return this.get().length;
    };

    this.get = () =>
    {
        if (!this.enabled()) {
            throw new Error('Basket is disabled!');
        }

        let all = Basket.getAll();

        return all.filter((itm) => {
            return itm.file ? true : false;
        });
    };

    this.download = () =>
    {
        if (!this.enabled()) {
            throw new Error('Basket is disabled!');
        }

        return $http.post('/api/baskets/archive')
        .then((response) =>
        {
            if (response.data.success) {
                return response.data;
            }

            notify.alert(response.data);
            return null;

        }).catch((response) => {
            notify.alert(response.data);
            return null;
        });
    };
}
